<template>
    <div>
        <div v-if="part === 'division'">
            <v-chip small color="default">
                <span class="mr-1">{{ comparison.original.gender.toUpperCase() }}</span>
                <span v-if="athleteLevel.isElite" class="mr-1">
                    {{ athleteLevel.short }}
                </span>
                <span v-else class="mr-1">
                    {{ athleteLevel.label }}
                </span>
                <span v-if="!athleteLevel.isElite">{{ comparison.original.age_group }}</span>
            </v-chip>
        </div>

        <div v-if="part === 'original_score'">
            <v-chip-group>
                <v-chip
                    small
                    :color="color"
                    text-color="white"
                    :href="$route('result-categories.show', { result_category: comparison.original.category_id })"
                >
                    <strong>{{ ordinal(comparison.original.prelims_placement) }}</strong>
                </v-chip>
                <v-chip
                    small
                    :color="color"
                    text-color="white"
                    :href="$route('result-categories.show', { result_category: comparison.original.category_id })"
                >
                    <strong class="mr-1">{{ comparison.original.prelims_score }}</strong>
                    Score
                </v-chip>
            </v-chip-group>
        </div>

        <div v-if="part === 'comparison'">
            <v-chip-group>
                <v-chip
                    small
                    :color="color"
                    text-color="white"
                    :href="$route('result-categories.show', { result_category: comparison.result_category_id })"
                >
                    <strong class="mr-1">{{ ordinal(comparison.comparison_placement) }}</strong>
                    /
                    <strong class="ml-1">{{ comparison.comparison_total }}</strong>
                </v-chip>
            </v-chip-group>
        </div>
    </div>
</template>

<script>
import { level, ordinal } from '@/helpers.js';

export default {
    name: 'ComparisonEvent',

    props: {
        comparison: {
            type: Object,
            required: true,
        },

        part: {
            type: String,
            required: false,
            default: 'division',
        },

        color: {
            type: String,
            required: false,
            default: 'primary',
        },
    },

    computed: {
        athleteLevel() {
            return level(this.comparison.original.level);
        },
    },

    methods: {
        level,
        ordinal,
    },
};
</script>
